<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}
</style>
<template>
	<div style="height: 100%;">
		<div class="manageselect">
			<div class="sclectlable">
				<div><el-input placeholder="请输入班级名" v-model="input" clearable></el-input></div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="value" clearable placeholder="请选择院校">
						<el-option v-for="item in options" :key="item.si_guid" :label="item.si_name_cn" :value="item.si_guid"></el-option>
					</el-select>
				</div>
			</div>

			<div class="primarybtn"><el-button type="primary" icon="el-icon-search" @click="get()">搜索</el-button></div>
		</div>

		<div class="primarybtn" style="margin-left: 10px;"><el-button type="success " icon="el-icon-search" @click="sets()">确定</el-button></div>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnum" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table
							:data="tableData"
							header-row-class-name="tablestitle"
							border
							ref="childtable"
							@select="selectionchange"
							@select-all="handleSelectAll"
							style="width: 100%"
						>
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="班级名" prop="cla_name"></el-table-column>
							<el-table-column label="学校名" prop="si_name_cn"></el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tabsnum }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="tabsnum"
							:total="totalall"
							:current-page="tabindex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { GetSchoolList, GetPageClassLists } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	data() {
		return {
			tableData: [],
			choicetableData: [],
			input: '',
			// 专业筛选项列表
			options: [],
			value: '',
			tabindex: 1,
			totalall: 0,
			tabsnum: 10,
			form: {
				name: '',
				zyguid: ''
			},
			gwname: '',
			zyguids: '',
			formLabelWidth: '120px',
			dialogFormVisible: false,
			edad: 0,
			prguid: ''
		};
	},
	mounted() {
		this.getscllist();
		this.get();
	},
	methods: {
		sets() {
			let nums = this.choicetableData.length;
			console.log(nums);
			if (nums > 0) {
				this.$emit('coust-change', this.choicetableData);
			} else {
				this.$message('请选择班级');
			}
		},
		changetablesize() {
			// this.tabsnum
			this.get();
		},
		clearstable(){
			this.$refs.childtable.clearSelection()
		},
		// 选择
		selectionchange(list, row) {
			if (this.choicetableData.find(item => item.cla_guid == row.cla_guid)) {
				//下面这个filter方法就是删除的方法
				this.choicetableData = this.choicetableData.filter(item => item.cla_guid != row.cla_guid);
			} else {
				this.choicetableData.push(row);
			}

			// console.log(this.choicetableData)
		},
		// 全选
		//该方法是当页全选的方法
		handleSelectAll(rows) {
			if (rows.length) {
				rows.forEach(row => {
					if (!this.choicetableData.find(item => item.cla_guid == row.cla_guid)) {
						this.choicetableData.push(row);
					}
				});
			} else {
				this.tableData.forEach(row => {
					this.choicetableData = this.choicetableData.filter(item => item.cla_guid != row.cla_guid);
				});
			}
		},
		get() {
			let changeobj = {
				pageIndex: this.tabindex,
				pageSize: this.tabsnum,
				cla_name: this.input,
				si_guid: this.value
			};

			GetPageClassLists(changeobj).then(res => {
				this.tableData = res.data.data.list;
				this.totalall = res.data.data.totalCount;

				if (this.choicetableData.length > 0) {
					this.$nextTick(() => {
						this.tableData.forEach((item, index) => {
							if (this.choicetableData.findIndex(v => v.cla_guid == item.cla_guid) >= 0) {
								// console.log('获取', this.$refs.childtable);
								this.$refs.childtable.toggleRowSelection(item, true);
							}
						});
					});
				}
			});
		},
		changeprlist(itm) {
			let itms = JSON.parse(JSON.stringify(itm));
			this.gwname = itms.PR_ProfessionalName;
			this.zyguids = itms.pro_guid;
			this.dialogFormVisible = true;
			this.prguid = itms.PR_GUID;
			this.edad = 1;
		},
		getscllist() {
			GetSchoolList().then(res => {
				// console.log(res)
				this.options = res.data.data;
			});
		},
		confirmpros(itm) {
			let delectobj = {
				PR_GUID: itm.PR_GUID
			};
			getDeleteStation(delectobj).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.get();
				}
			});
		},

		changecurr(val) {
			this.tabindex = val;
			this.get();
		}
	}
};
</script>
